import { BenchmarkThresholds } from '../Benchmark'
import { AggregatedServiceReport, TransactionReport } from './ServiceReport'

export interface TransactionTrendReport {
    id: number | string
    active: boolean
    name: string
    identifier: string
    benchmark?: BenchmarkThresholds | null
    impact: number
    range: { startDate: string; endDate: string }
    requests: number
    requestsChange: number
    averageResponse: number
    averageResponseChange: number
    worstResponse: number
    worstResponseChange: number
    maxResponse: number
    maxResponseChange: number
    avgMemory: number
    avgMemoryChange: number
    errors: number
    errorsChange: number
    groups: { [key: string]: GroupItem }
}

interface GroupItem {
    range: { startDate: string; endDate: string }
    requests: number
    averageResponse: number
    worstResponse: number
    maxResponse: number
    avgMemory: number
    impact: number
    days: number
}

export const createTransactionTrendReport = (
    id: string | number,
    transaction: TransactionReport<any>,
    reports: AggregatedServiceReport[],
): TransactionTrendReport => {
    const report = reports[reports.length - 1]

    if (!transaction) {
        throw Error('no transaction')
    }

    let comparisonTransaction
    if (reports.length > 1) {
        comparisonTransaction = reports[reports.length - 2].transactions[id]
    }

    const groups = createGroups(id, reports)

    return {
        id,
        active: transaction.active,
        name: transaction.name,
        identifier: transaction.identifier,
        benchmark: transaction.benchmark ?? null,
        impact: transaction.impact,
        range: { startDate: report.days[0], endDate: report.days[0] },
        requests: transaction.requests,
        requestsChange: calcChange(transaction, comparisonTransaction, 'requests'),
        worstResponse: transaction.worst_response,
        worstResponseChange: calcChange(transaction, comparisonTransaction, 'worst_response'),
        maxResponse: transaction.max,
        maxResponseChange: calcChange(transaction, comparisonTransaction, 'max'),
        averageResponse: transaction.average_response,
        averageResponseChange: calcChange(transaction, comparisonTransaction, 'average_response'),
        avgMemory: transaction.memory,
        avgMemoryChange: calcChange(transaction, comparisonTransaction, 'memory'),
        errors: transaction.errors,
        errorsChange: calcChange(transaction, comparisonTransaction, 'errors'),
        groups,
    }
}

const calcChange = (transaction: any, comparison: any | null, field: string): number =>
    !comparison ? 0 : (transaction[field] / comparison[field]) * 100 - 100

const createGroups = (id: string | number, reports: AggregatedServiceReport[]): any => {
    const groups = {}

    reports.map((report: AggregatedServiceReport) => {
        const transaction = report.transactions[id]

        groups[report.days[0]] = {
            averageResponse: transaction ? transaction.average_response : 0,
            avgMemory: transaction ? transaction.memory : 0,
            days: report.days.length,
            impact: transaction ? transaction.impact : 0,
            range: { startDate: report.days[0] + ' 00:00:00', endDate: report.days[report.days.length - 1] + ' 23:59:59' },
            requests: transaction ? transaction.requests : 0,
            worstResponse: transaction ? transaction.worst_response : 0,
        }
    })

    return groups
}
